import React from "react";
import { Form } from "react-bootstrap";
import { countryFilter } from "../../utilities/const";

const CountryFilter = ({ body, setBody }) => {
  const handleChange = (e) => {
    const { value } = e.target;
    setBody((prev) => ({
      ...prev,
      country: value,
    }));
  };

  return (
    <Form.Select
      className="select text-muted"
      aria-label="Country filter"
      value={body?.country || ""}
      onChange={handleChange}
    >
      {countryFilter?.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </Form.Select>
  );
};

export default CountryFilter;
